import React from 'react';

/**
 * Skeleton component for loading states.
 * Uses the .skeleton-shimmer class from index.css.
 */
const Skeleton = ({ className = '', width, height, borderRadius = '0.75rem' }) => {
  return (
    <div
      className={`skeleton-shimmer ${className}`}
      style={{
        width: width || '100%',
        height: height || '1rem',
        borderRadius: borderRadius,
      }}
    />
  );
};

export default Skeleton;
